import { Picture } from './picture.js';

const ReviewBaseMixin = Base =>
  class ReviewBase extends Base {
    constructor(data, loc) {
      super();

      this.#loc = loc;
      this.setData(data);
    }

    get id() {
      return this.data.id;
    }

    get loc() {
      return this.#loc;
    }

    get headline() {
      return this.data.headline;
    }

    get text() {
      return this.data.text;
    }

    get date() {
      let date =
        this.data.date instanceof Date
          ? this.data.date.toISOString()
          : this.data.date ?? '';
      return date.substring(0, 10);
    }

    get formattedDate() {
      if (!this.data.date) {
        return '';
      }

      let options = {
        year: 'numeric',
        month: 'long',
        timeZone: 'UTC',
      };
      if (!this.data.dateIsApproximate) {
        options.day = 'numeric';
      }
      return new Intl.DateTimeFormat('en-US', options).format(
        new Date(this.data.date)
      );
    }

    get dateIsApproximate() {
      return this.data.dateIsApproximate;
    }

    get thumbnailPicUrls() {
      return Picture.toThumbnailUrls(this.data.pics);
    }

    get overallRating() {
      let rating = (this.data.ratings ?? []).find(
        rating => rating[0] == 'overall'
      );
      return rating?.[1] ?? 0;
    }

    get ratingsByGroups() {
      let { ratings } = this;
      return this.#loc.ratingInfo
        .map(group =>
          Object.assign({
            id: group.id,
            label: group.label,
            ratings: ratings.filter(rating => rating.group?.id == group.id),
          })
        )
        .filter(group => group.ratings.length > 0);
    }

    get ratings() {
      let date = this.date;
      return (this.data.ratings || []).map(([id, value]) =>
        Object.assign(
          {
            id,
            date,
            value,
          },
          this.ratingInfoBy(id)
        )
      );
    }

    getRatingsBy(groupId) {
      return this.ratings.filter(
        rating => rating.group && rating.group.id == groupId
      );
    }

    ratingInfoBy(ratingId) {
      for (let ratingGroup of this.#loc.ratingInfo) {
        for (let ratingItem of ratingGroup.items) {
          if (ratingItem.id == ratingId) {
            return Object.assign({ group: ratingGroup }, ratingItem);
          }
        }
      }
      return {};
    }

    get canEdit() {
      return this.data.canEdit;
    }

    get canDelete() {
      return this.data.canDelete;
    }

    setData(data) {
      this.data = data;
    }

    #loc;
  };

export { ReviewBaseMixin };
